import { render, staticRenderFns } from "./IncidentRecords.vue?vue&type=template&id=6ec1c825&scoped=true"
import script from "./IncidentRecords.vue?vue&type=script&lang=js"
export * from "./IncidentRecords.vue?vue&type=script&lang=js"
import style0 from "./IncidentRecords.vue?vue&type=style&index=0&id=6ec1c825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec1c825",
  null
  
)

export default component.exports